import React from 'react';
import glamorous from 'glamorous';
import FontIcon from 'react-toolbox/lib/font_icon';

const HeaderContainer = glamorous.h3({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  '&:hover': { cursor: 'pointer' },
});
const HeaderIcon = glamorous(FontIcon, {
  rootEl: 'span',
  forwardProps: ['children', 'className', 'value'],
})(
  {
    alignSelf: 'center',
    transition: 'transform .45s linear',
  },
  ({ collapsed }) => {
    return collapsed ? { transform: 'rotate(180deg)' } : {};
  }
);

const AccordionHeader = ({
  title,
  icon,
  collapsed,
  toggleCollapsed,
  ...restProps
}) => {
  return (
    <HeaderContainer {...restProps} onClick={toggleCollapsed}>
      <span style={{ alignSelf: 'center' }}>{title || ''}</span>
      <HeaderIcon collapsed={collapsed} value={icon || 'keyboard_arrow_up'} />
    </HeaderContainer>
  );
};

export default AccordionHeader;



// WEBPACK FOOTER //
// ./src/App/account/components/Accordion/DefaultComponents/Header.js